





















import { Component, Vue } from 'vue-property-decorator'
import NewModuleForm from '@/components/Programmation/NewModuleForm.vue'
import Alert from '@/components/Alert.vue'

@Component({
    components: {
        Alert,
        NewModuleForm,
    },
})
export default class NewModuleBloc extends Vue {
    mounted() {
        const $newModuleModal: any = $(this.$refs.newModuleModal)
        $newModuleModal.on('hidden.bs.modal', this.cleanupNewModuleModal)
    }

    destroyed() {
        const $newModuleModal: any = $(this.$refs.newModuleModal)
        $newModuleModal.off('hidden.bs.modal', this.cleanupNewModuleModal)
    }

    showNewModuleModal() {
        const $newModuleModal: any = $(this.$refs.newModuleModal)
        $newModuleModal.modal('show')
    }

    onAlert(alert: { type: string; message: string; duration: number }) {
        const $newModuleModal: any = $(this.$refs.newModuleModal)
        $newModuleModal.modal('hide')

        const $alert = this.$refs.alert as Alert
        if (alert.duration) {
            $alert.handleAlert(alert.type, alert.message, alert.duration)
        } else {
            $alert.handleAlert(alert.type, alert.message)
        }
    }

    cleanupNewModuleModal() {
        const newModuleForm = this.$refs.newModuleForm as any
        newModuleForm.reset()
    }
}
